import type { BrainstormCategory } from '../../api/types'

export const BRAINSTORM_CATEGORY_LABELS: Record<BrainstormCategory, string> = {
  CONCEPT: 'Konzeptideen',
  SCRIPT: 'Grundgerüstscripts',
  THOUGHT: 'Gedankengänge',
  REQUIREMENT: 'Was benötigen wir',
}

export const BRAINSTORM_CATEGORY_BADGE: Record<BrainstormCategory, 'info' | 'success' | 'warning' | 'neutral'> = {
  CONCEPT: 'info',
  SCRIPT: 'success',
  THOUGHT: 'neutral',
  REQUIREMENT: 'warning',
}
